import { motion } from 'framer-motion';
import VideoPoster from '../../assets/535fbac30da553a0.jpg';
import Video from '../../assets/535fbac30da553a0.mp4';
import { CenterLayout, FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H0 } from '../../common/common-text';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const VisionSection1 = () => {
  const { isMobile } = useDeviceType();
  const { topSectionBottom: bottomPadding } = useResponsivePadding();
  const viewheight = useVisualViewportHeight();

  return (
    <VerticalLayout style={{ background: 'black', height: isMobile ? viewheight : '100vh', overflow: 'hidden' }}>
      <FrameLayout>
        {/* 비디오 크롭 → 원래 위치로 애니메이션 */}
        <motion.div
          initial={{
            clipPath: 'inset(30% 30% 30% 30%)', // 위, 오른쪽, 아래, 왼쪽 25%씩 잘림 (중앙 50%만 보임)
            scale: 0.8,
          }}
          animate={{
            clipPath: 'inset(0% 0% 0% 0%)', // 전체 노출
            scale: 1.0,
          }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.5 }}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <video
            src={Video}
            autoPlay
            muted
            loop
            playsInline
            poster={VideoPoster}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </motion.div>

        {/* 텍스트 애니메이션 */}
        <motion.div
          initial={{ y: 400 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut', delay: 1.4 }}
          style={{
            position: 'absolute',
            bottom: bottomPadding,
            transform: 'translateX(-50%)',
            width: '100%',
          }}
        >
          <CenterLayout style={{ width: '100%' }}>
            <H0 style={{ color: 'white' }}>BBTECH</H0>
          </CenterLayout>
        </motion.div>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default VisionSection1;
